import { Link } from 'react-router-dom'
import styles from './SnowballCTA.module.scss'

const SnowballCTA = () => {
    return (
        <div className={styles['snowball-cta']}>
            <div className={styles['snowball-cta__inner']}>
                <h2 className={styles['snowball-cta__title']}>
                    Ready to start paying off debt?
                </h2>
                
                <p className={styles['snowball-cta__description']}>
                    Our debt snowball tool will help you determine the best way to pay off your debt and will automatically create the transactions and add them to your budget.
                </p>

                <Link className='button button-green' to='/tools/debt-snowball'>
                    Snowball Your Debt
                </Link>

                <p className={styles['snowball-cta__note']}>
                    Note: This tool is only available to users with a paid subscription.
                </p>
            </div>
        </div>
    )
}

export default SnowballCTA